import { DispatchType, StoreAction } from "../reduxTypes";
import { parseError } from "../../utils/http-helper";
import { getSession } from "../../utils/session-helper";
import documentosService from "../../services/documentos";

export const DOCUMENTOS__SET_DADOS_ARQUIVOS = "DOCUMENTOS__SET_DADOS_ARQUIVOS";
export const DOCUMENTOS__SET_LOADING = "DOCUMENTOS__SET_LOADING";

function setDadosArquivos(dados: Object): StoreAction {
  return {
    type: DOCUMENTOS__SET_DADOS_ARQUIVOS,
    payload: dados,
  };
}

function setLoading(l: boolean): StoreAction {
  return {
    type: DOCUMENTOS__SET_LOADING,
    payload: l,
  };
}

function buscarArquivos() {
  return async function (dispatch: DispatchType) {
    const { userData } = await getSession();
    if (!userData) return;

    dispatch(setLoading(true));
    return documentosService
      .buscarDocumentos()
      .then((resp) => {
        const { data } = resp;

        const dados = data ?? [];

        dispatch(setDadosArquivos(dados));
      })
      .catch((error) => {
        parseError(error, "Erro ao tentar conectar");
      })
      .finally(() => dispatch(setLoading(false)));
  };
}

const documentosActions = { buscarArquivos };

export default documentosActions;
